module.exports = __webpack_public_path__ + "img/home1.32c501fb.png";